var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "cae16f43a1eaf56ffbd4ec4b1bf0574f290d731c"
};